
import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { decryptData, defaulUrl, photoUrl } from "../components/const";
import Swal from "sweetalert2";
import UseFetch from "../components/UseFetch";

import ModalPubMedia from "./AddMedia";
import ModalEditPubMedia from "./EditeMedia";

const DashboardSite = () => {
    const { data: infos, isloading, refresh } = UseFetch('show-info-site')
    const [isLoading, setIsLoading] = useState(false)
    const [firtload, setFirstLoad] = useState(true)
    const [openModal, setOpenModal] = useState(false);
    const [openEditeModal, setOpenEditeModal] = useState(false);
    const [selecteMedia, setSelectedMedia] = useState(null)
    const [serviceIdToEdit, setServiceIdToEdit] = useState(null);
    // GESTION SERVICE
    const [titre, setTitre] = useState("");
    const [description, setDescription] = useState("");

    const [formData, setFormData] = useState({
        adresse: '',
        telephone: '',
        email: '',
        whatsapp: '',
        facebook: '',
        about_page: '',
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    // pour la mise en forme du champ a propos
    const modules = {
        toolbar: [
            [{ header: [1, 2, 3, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ align: [] }],
            ['clean']
        ]
    };


    const handleSubmit = async () => {
        setIsLoading(true)
        try {
            const response = await fetch(`${defaulUrl}admin-site/add-info`, {
                method: 'POST',
                headers: {

                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + decryptData('ACCESS_TOKEN'),
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();
            setIsLoading(false)
            if (response.ok) {
                Swal.fire({ tilte: "Succes", text: 'Informations enregistrées avec succès', icon: "success" });
                refresh()
            } else {
                Swal.fireert({ title: "Erreur", text: 'Erreur : ' + result.message, icon: 'error' });
            }
        } catch (error) {
            console.error('Erreur de soumission :', error);
            Swal.fire({ title: "Erreur", text: 'Erreur lors de l’envoi', icon: 'error' });
        }
    };

    async function handleAddService(titre, description) {
        try {
            const response = await fetch(`${defaulUrl}admin-site/add-service`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${decryptData("ACCESS_TOKEN")}`,
                },
                body: JSON.stringify({ titre, description }),
            });

            if (response.ok) {
                Swal.fire("Succès", "Service ajouté avec succès !", "success");
                setTitre("");
                setDescription("");
                document.getElementById("closeModalBtn").click(); // Ferme le modal
                refresh()
            } else {
                const errorData = await response.json();
                Swal.fire("Erreur", errorData.message || "Échec de l’ajout.", "error");
            }
        } catch (error) {
            Swal.fire("Erreur réseau", "Vérifiez votre connexion.", "error");
        }
    }

    const handleSubmitService = (e) => {
        e.preventDefault();
        if (!titre || !description) {
            Swal.fire("Champs requis", "Remplis tous les champs", "warning");
            return;
        }
        handleAddService(titre, description);
    };


    async function handleEditService(id, titre, description) {
        try {
            const response = await fetch(`${defaulUrl}admin-site/update-service/${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${decryptData('ACCESS_TOKEN')}`,
                },
                body: JSON.stringify({ titre, description }),
            });

            if (response.ok) {
                Swal.fire({
                    icon: 'success',
                    title: 'Modifié',
                    text: 'Service modifié avec succès !',
                });
                refresh()
            } else {
                const errorData = await response.json();
                Swal.fire({
                    icon: 'error',
                    title: 'Erreur',
                    text: errorData.message || 'Erreur lors de la modification.',
                });
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Erreur',
                text: 'Erreur réseau. Veuillez réessayer.',
            });
        }
    }


    function fillEditForm(titre, description) {
        document.getElementById("editTitre").value = titre;
        document.getElementById("editDescription").value = description;
    }



    async function handleDeleteService(id) {
        const confirmation = await Swal.fire({
            title: 'Supprimer ?',
            text: "Cette action est irréversible !",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Oui, supprimer',
            cancelButtonText: 'Annuler',
        });

        if (!confirmation.isConfirmed) return;
        try {
            const response = await fetch(`${defaulUrl}admin-site/delete-service/${id}`, {
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${decryptData('ACCESS_TOKEN')}`,
                },
            });

            if (response.ok) {
                Swal.fire({
                    icon: 'success',
                    title: 'Supprimé',
                    text: 'Service supprimé avec succès !',
                });
                refresh()
            } else {
                const errorData = await response.json();
                Swal.fire({
                    icon: 'error',
                    title: 'Erreur',
                    text: errorData.message || 'Erreur lors de la suppression.',
                });
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Erreur',
                text: 'Erreur réseau. Veuillez réessayer.',
            });
        }
    }

    async function handleDeleteMedia(media) {
        const confirmation = await Swal.fire({
            title: 'Supprimer ?',
            text: "Cette action est irréversible !",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Oui, supprimer',
            cancelButtonText: 'Annuler',
        });

        if (!confirmation.isConfirmed) return;
        try {
            const response = await fetch(`${defaulUrl}admin-site/delete-${media?.image ? 'image' : 'video'}/${media?.id}`, {
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${decryptData('ACCESS_TOKEN')}`,
                },
            });

            if (response.ok) {
                Swal.fire({
                    icon: 'success',
                    title: 'Supprimé',
                    text: 'Suppression effectuee avec succes !',
                });
                refresh()
            } else {
                const errorData = await response.json();
                Swal.fire({
                    icon: 'error',
                    title: 'Erreur',
                    text: errorData.message || 'Erreur lors de la suppression.',
                });
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Erreur',
                text: 'Erreur réseau. Veuillez réessayer.',
            });
        }
    }

    async function handleDeletAvis(avis) {
        const confirmation = await Swal.fire({
            title: 'Supprimer ?',
            text: "Cette action est irréversible !",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Oui, supprimer',
            cancelButtonText: 'Annuler',
        });

        if (!confirmation.isConfirmed) return;
        try {
            const response = await fetch(`${defaulUrl}admin-site/delete-avis/${avis?.id}`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${decryptData('ACCESS_TOKEN')}`,
                },
            });

            if (response.ok) {
                Swal.fire({
                    icon: 'success',
                    title: 'Supprimé',
                    text: 'Suppression effectuee avec succes !',
                });
                refresh()
            } else {
                const errorData = await response.json();
                Swal.fire({
                    icon: 'error',
                    title: 'Erreur',
                    text: errorData.message || 'Erreur lors de la suppression.',
                });
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Erreur',
                text: 'Erreur réseau. Veuillez réessayer.',
            });
        }
    }

    useEffect(() => {
        if (infos && firtload) {
            setFormData({
                adresse: infos?.info_site?.adresse ?? '',
                telephone: infos?.info_site?.telephone ?? '',
                email: infos?.info_site?.email ?? '',
                whatsapp: infos?.info_site?.whatsapp ?? '',
                facebook: infos?.info_site?.facebook ?? '',
                about_page: infos?.info_site?.about_page ?? '',
            });
            setFirstLoad(false)
        }
    }, [infos]);


    return (
        <div className="container">
            {(isLoading || isloading) && <div className="loader"></div>}
            <h2 className="text-primary text-center">Administration du site</h2>
            <div className="row gap-1 bg-white p-2 my-2">
                <h4>Informations de contact</h4>
                <div className="d-flex align-items-center gx-3  col-md-3 flex-grow-1" >
                    <span className="bg-primary m-2 p-2 rounded-1 text-white h-auto ">
                        <i className="bx bx-home   fs-3 "></i>
                    </span>
                    <div className="form-group w-100">
                        <label>Address</label>
                        <input type="text" className="form-control" name="adresse" value={formData?.adresse} onChange={handleChange} />
                    </div>
                </div>
                <div className="d-flex align-items-center gx-3  col-md-3 flex-grow-1" >
                    <span className="bg-primary m-2 p-2 rounded-1 text-white h-auto ">
                        <i className="bx bx-phone   fs-3 "></i>
                    </span>
                    <div className="form-group w-100">
                        <label>Contacts</label>
                        <input type="text" className="form-control  " name="telephone"
                            value={formData?.telephone}
                            onChange={handleChange} />
                    </div>
                </div>
                <div className="d-flex align-items-center    col-md-3 flex-grow-1" >
                    <span className="bg-primary m-2 p-2 rounded-1 text-white h-auto ">
                        <i className="bx bx-envelope   fs-3 "></i>
                    </span>
                    <div className="form-group w-100">
                        <label>Email</label>
                        <input type="text" className="form-control  " name="email"
                            value={formData?.email}
                            onChange={handleChange} />
                    </div>
                </div>
                <div className="d-flex align-items-center p-2   col-md-4  " >
                    <span className="bg-primary m-2 p-2 rounded-1 text-white h-auto ">
                        <i className="bx bx-phone fs-3"></i>
                    </span>
                    <div className="form-group w-100">
                        <label>Whatsapp</label>
                        <input type="text" className="form-control  " name="whatsapp"
                            value={formData?.whatsapp}
                            onChange={handleChange} />
                    </div>
                </div>
                <div className="d-flex align-items-center p-2   col-md-4  " >
                    <span className="bg-primary m-2 p-2 rounded-1 text-white h-auto ">
                        <i className="  bi bi-facebook fs-3">f</i>
                    </span>
                    <div className="form-group w-100">
                        <label>Facebook</label>
                        <input type="text" className="form-control  " name="facebook"
                            value={formData?.facebook}
                            onChange={handleChange} />
                    </div>
                </div>
                <div className="container p-2  my-2">
                    <h4>Page à propos</h4>
                    <div>
                        <ReactQuill modules={modules} value={formData?.about_page}
                            onChange={(value) => setFormData({ ...formData, about_page: value })} />

                    </div>
                </div>
                <button className="btn btn-primary ms-auto w-auto h-25  mt-auto" onClick={handleSubmit}>Enregistrer</button>
            </div>
            <div className="row gap-1 bg-white p-2 my-2">
                <div className="row justify-content-between align-items-center">
                    <div className="col-md-8">
                        <h4>Images publicitaires</h4>
                    </div>
                    <button className="btn btn-primary btn w-auto" onClick={() => setOpenModal(true)}>Ajouter Image</button>
                </div>
                {infos?.images?.length ?
                    infos?.images?.map((img, ind) =>
                        <div className="col-md-3 p-1 m-1 flex-grow-1" key={ind}>
                            <div className="card h-100 p-2">
                                <div className="card-header">
                                    <div className="card-title">{img.titre}</div>
                                </div>
                                <div className="card-body">

                                    < img src={`${photoUrl}Publicite/${img.image}`} alt="" className="card-image  w-100 text-center" />
                                    <p className="card-text">{img.description}.</p>
                                </div>
                                <div className="modal-footer   ">
                                    <button className="btn btn-primary m-1" onClick={() => {

                                        setSelectedMedia(img);
                                        setOpenEditeModal(true);

                                    }}><i className="bx bx-edit ms-auto"></i></button>
                                    <button className="btn btn-danger m-1" onClick={() => handleDeleteMedia(img)}><i className="bx bx-trash ms-auto"></i></button>
                                </div>
                            </div>
                        </div>
                    )
                    : <div className="p-3 bg-secondary-subtle text-danger text-center">Aucune image disponible</div>
                }


            </div>

            <div className="row gap-1 bg-white p-2 my-2">
                <div className="row justify-content-between align-items-center">
                    <div className="col-md-8">
                        <h4>Videos publicitaires</h4>
                    </div>
                    <button className="btn btn-primary btn w-auto" onClick={() => setOpenModal(true)}>Ajouter video</button>
                </div>

                {infos?.videos?.length ?
                    infos?.videos?.map((video, ind) =>
                        <div className="col-md-3 flex-grow-1 p-2" key={ind}>
                            <iframe
                                width="100%"
                                height="360"
                                src={`${photoUrl}Publicite/${video.video}`}
                                frameBorder="0"
                                allowFullScreen
                                title="pub-1"
                            />
                            <p className="p-2">
                                <strong>{video.titre}</strong><br />
                                {video.description}
                            </p>
                            <div className="modal-footer   ">
                                <button className="btn btn-primary m-1" onClick={() => {

                                    setSelectedMedia(video);
                                    setOpenEditeModal(true);

                                }}><i className="bx bx-edit ms-auto"></i></button>
                                <button className="btn btn-danger m-1" onClick={() => handleDeleteMedia(video)}><i className="bx bx-trash ms-auto"></i></button>
                            </div>
                        </div>
                    )
                    : <div className="p-3 bg-secondary-subtle text-danger text-center">Aucune video disponible</div>
                }




            </div>




            <div className="row gap-1 bg-white p-2 my-2">
                <div className="row justify-content-between align-items-center">
                    <div className="col-md-8">
                        <h4>Nos services & offres</h4>
                    </div>
                    <button className="btn btn-primary w-auto"
                        data-bs-toggle="modal"
                        data-bs-target="#addServiceModal">Ajouter</button>
                </div>
                {infos?.services.length > 0 ? infos?.services?.map((ser, ind) =>
                    <div className="col-md-3 p-1 m-1 flex-grow-1" key={ind}>
                        <div className="card h-100  ">
                            <div className="fw-bold bg-secondary-subtle text-center py-2">
                                <div className="card-title">{ser.titre}</div>
                            </div>
                            <div className="card-body">

                                <p className="card-text">{ser.description}</p>
                            </div>
                            <div className="modal-footer   ">
                                <button className="btn btn-primary m-1"
                                    data-bs-toggle="modal"
                                    data-bs-target="#editServiceModal"
                                    onClick={() => {
                                        fillEditForm(ser.titre, ser.description);
                                        setServiceIdToEdit(ser.id);
                                    }}><i className="bx bx-edit ms-auto"></i></button>
                                <button className="btn btn-danger m-1" onClick={() => handleDeleteService(ser.id)}><i className="bx bx-trash ms-auto"></i></button>
                            </div>
                        </div>
                    </div>
                ) : <div className="p-3 bg-secondary-subtle text-danger text-center">Aucun service disponible</div>
                }



            </div>



            <div className="row gap-1 bg-white p-2 my-2">
                <h4>Gestion des avis</h4>


                {(infos?.avis?.length > 0) ?
                    infos.avis.map((av, ind) => <div className="col-md-2 p-1 m-1  " key={ind}>
                        <div className="card h-100 p-2">
                            <div className="card-title fw-bold fs-6">{av.nom_complet}</div>
                            <div className="card-body">
                                <p className="card-text text-Capitalize">{av.message}.</p>
                            </div>
                            <div className="modal-footer   ">
                                <button className="btn btn-danger m-1" onClick={() => handleDeletAvis(av)}><i className="bx bx-trash ms-auto"></i></button>
                            </div>
                        </div>
                    </div>) : <div className="p-3 bg-secondary-subtle text-danger text-center">Aucun avis disponible</div>
                }



            </div>




            <ModalPubMedia
                isOpen={openModal}
                onClose={() => { setOpenModal(false); refresh() }}

            />
            <ModalEditPubMedia isOpen={openEditeModal} onClose={() => { setOpenEditeModal(false); refresh() }} media={selecteMedia} />


            {/* MODAL ADD SERVICES */}
            <div
                className="modal fade"
                id="addServiceModal"
                tabIndex="-1"
                aria-labelledby="addServiceModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <form onSubmit={handleSubmitService}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="addServiceModalLabel">
                                    Ajouter un service
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    id="closeModalBtn"
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-3">
                                    <label className="form-label">Titre</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={titre}
                                        onChange={(e) => setTitre(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Description</label>
                                    <textarea
                                        className="form-control"
                                        rows="4"
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                        required
                                    ></textarea>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >
                                    Annuler
                                </button>
                                <button type="submit" className="btn btn-primary">
                                    Enregistrer
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            {/* MODAL EDITE SERVICE */}
            <div className="modal fade" id="editServiceModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Modifier le service</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">
                            <form id="editServiceForm">
                                <div className="mb-3">
                                    <label className="form-label">Titre</label>
                                    <input type="text" id="editTitre" className="form-control" />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Description</label>
                                    <textarea id="editDescription" className="form-control" />
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" data-bs-dismiss="modal">Annuler</button>
                            <button
                                className="btn btn-success"
                                onClick={() => {
                                    const titre = document.getElementById("editTitre").value;
                                    const description = document.getElementById("editDescription").value;
                                    if (serviceIdToEdit) {
                                        handleEditService(serviceIdToEdit, titre, description);
                                    }
                                }}
                            >
                                Modifier
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </div >
    );
}

export default DashboardSite;